import * as React from 'react';
import { Composites, InfoIcon, TextLabel, SectionDivider, Divider, } from '@wix/wix-base-ui';
export var SectionHeader = function (_a) {
    var text = _a.text, tooltipText = _a.tooltipText, tooltipTitle = _a.tooltipTitle, dataHook = _a.dataHook;
    return (React.createElement("div", { "data-hook": dataHook },
        React.createElement(Divider, { long: true }),
        React.createElement(Composites.SectionDividerWithInfoIcon, null,
            tooltipText && (React.createElement(InfoIcon, { title: tooltipTitle, text: tooltipText, automationId: dataHook ? dataHook + "-info-icon" : null })),
            React.createElement(SectionDivider, null,
                React.createElement(TextLabel, { value: text, automationId: dataHook ? dataHook + "-label" : null }))),
        React.createElement(Divider, { long: true })));
};
//# sourceMappingURL=SectionHeader.js.map